export default "__VITE_ASSET__BX7nr3ey__"